// import React, { useState } from "react";
// import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
// import facebook from "../../Asset/facebook_f.svg";
// import instagram from "../../Asset/instagram_f.svg";
// import { ReactSVG } from "react-svg";
// import microsoftIcon from "../../Asset/microsoft icon.svg";
// import playStore from "../../Asset/paly store.svg";
// import { NavLink } from "react-router-dom";
// import { toast } from "react-toastify";
// import ButtonLoading from "../ButtonLoading";
// import success from "../../Asset/success.png";
// import error from "../../Asset/error.png";

// const Footer = () => {
//   const pages = [
//     { name: "Home", link: "/" },
//     { name: "Demo", link: "/demo" },
//     { name: "Pricing", link: "/pricing" },
//     { name: "Help", link: "/help" },
//   ];
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isOpenSuccess, setIsOpenSuccess] = useState(false);
//   const [isOpenError, setIsOpenError] = useState(false);

//   const sendToZohoBigin = async () => {
//     if (!email) {
//       toast.error("Please enter the email");

//       return;
//     }
//     setLoading(true);
//     const data = {
//       data: [
//         { Last_Name: email, Email: email, Lead_Source: "Website Subscription" },
//       ],
//     };

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_URL}proxy/zoho`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(data),
//         }
//       );

//       if (response.ok) {
//         setIsOpenSuccess(true);
//         setEmail("");
//       } else {
//         setIsOpenError(true);
//       }
//     } catch (error) {
//       setIsOpenError(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className=" bg-gradient-to-b from-[#F8F8F8] to-[#F8F8FC00]  w-full font-inter">
//         <div className=" w-full  flex flex-col xl:gap-10 gap-6">
//           <div className="  border-y xl:px-20  lg:px-10 px-6 py-4 border-[#0000000D] ">
//             <div className="max-w-screen-2xl mx-auto flex md:flex-row flex-col md:justify-between items-start md:items-center w-full md:gap-0 gap-2">
//               <div className="w-full">
//                 <ReactSVG
//                   src={zeroTypingLogo}
//                   beforeInjection={(svg) => {
//                     svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8 ");
//                   }}
//                   className=""
//                 />
//               </div>

//               <div className="w-full flex justify-start md:gap-6 gap-3 md:text-sm text-xs font-medium">
//                 {pages?.map((page, i) => (
//                   <NavLink
//                     to={page.link}
//                     key={i}
//                     className="hover:text-[#3AB1F6] text-[#292D34] md:pl-8 pl-3 md:first:pl-3 first:pl-0 md:pr-5 border-l border-[#0000000D] md:first:border-l-1 first:border-l-0 gap-6"
//                   >
//                     {page.name}
//                   </NavLink>
//                 ))}
//               </div>
//             </div>


//           </div>
//           <div className="xl:px-20 lg:px-10 px-6 ">
//             <div className=" flex md:flex-row flex-col md:items-center max-w-screen-2xl  mx-auto w-full items-start md:gap-4 gap-8 ">
//               <div className=" flex-1 w-full flex flex-col gap-4 xl:text-lg lg:text-base md:text-sm text-xs items-start">
//                 <p>
//                   Say goodbye to typos and wasted time—Zerotyping AI{" "}
//                   <br className=" lg:flex hidden" /> writes with precision, so
//                   you don’t have to.
//                 </p>
//                 {/* <div className=" flex items-center gap-3 font-inter">
//                   <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
//                     <ReactSVG
//                       src={microsoftIcon}
//                       beforeInjection={(svg) => {
//                         svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
//                       }}
//                     />
//                     <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
//                       <span className=" text-[.6rem] leading-none">
//                         Download for
//                       </span>
//                       <span className=" font-semibold leading-none">
//                         Windows
//                       </span>
//                     </div>
//                   </button>


//                   <a
//                     href="https://play.google.com/store/apps/details?id=ai.zerotyping"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="inline-block"
//                   >
//                     <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
//                       <ReactSVG
//                         src={playStore}
//                         beforeInjection={(svg) => {
//                           svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
//                         }}
//                       />
//                       <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
//                         <span className=" text-[.6rem] leading-none">
//                           GET IT ON
//                         </span>
//                         <span className=" font-semibold leading-none">
//                           Google Play
//                         </span>
//                       </div>
//                     </button>
//                   </a>
//                 </div> */}
//                 <div className=" flex items-center gap-4">
//                   <ReactSVG
//                     src={facebook}
//                     beforeInjection={(svg) => {
//                       svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
//                     }}
//                     className="w-auto"
//                   />
//                   <ReactSVG
//                     src={instagram}
//                     beforeInjection={(svg) => {
//                       svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
//                     }}
//                     className="w-auto"
//                   />
//                 </div>
//               </div>
//               <div className=" flex-1 w-full flex md:justify-end justify-center ">
//                 <div className="bg-[#00000005] border border-[#0000000D] flex flex-col gap-4 lg:p-6 p-3 rounded-xl lg:w-[470px] w-full">
//                   <p className="md:text-sm text-xs font-inter">
//                     Sign up for our newsletter and join the Transparent
//                     community.
//                   </p>
//                   <div className=" flex md:items-center items-start flex-row gap-2 w-full md:text-sm text-xs">
//                     <input
//                       type="email"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                       className=" flex-grow bg-[#fff] lg:w-auto w-full md:p-3  p-2 rounded-lg  placeholder:text-[#757575]"
//                       placeholder="Input Email Address"
//                     />
//                     <button
//                       onClick={() => {
//                         sendToZohoBigin();
//                       }}
//                       disabled={loading}
//                       className={`flex-none flex items-center justify-center ${loading ? " opacity-50 cursor-not-allowed" : ""
//                         } bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out lg:w-auto w-max md:p-3  p-2 md:px-4 px-2  rounded-lg  text-[#fff]`}
//                     >
//                       {loading ? (
//                         <ButtonLoading text="subscribing..." />
//                       ) : (
//                         "Subscribe"
//                       )}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className=" text-sm font-inter flex flex-col gap-4 lg:py-10 py-6 border-t xl:px-20  lg:px-10 px-6  border-[#0000000D] ">
//             <div className="max-w-screen-2xl  mx-auto flex md:flex-row flex-col-reverse gap-4 justify-between md:items-center items-start w-full ">

//               <div className=" flex items-center gap-3 font-inter">
//                 <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
//                   <ReactSVG
//                     src={microsoftIcon}
//                     beforeInjection={(svg) => {
//                       svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
//                     }}
//                   />
//                   <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
//                     <span className=" text-[.6rem] leading-none">
//                       Download for
//                     </span>
//                     <span className=" font-semibold leading-none">
//                       Windows
//                     </span>
//                   </div>
//                 </button>


//                 <a
//                   href="https://play.google.com/store/apps/details?id=ai.zerotyping"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-block"
//                 >
//                   <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
//                     <ReactSVG
//                       src={playStore}
//                       beforeInjection={(svg) => {
//                         svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
//                       }}
//                     />
//                     <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
//                       <span className=" text-[.6rem] leading-none">
//                         GET IT ON
//                       </span>
//                       <span className=" font-semibold leading-none">
//                         Google Play
//                       </span>
//                     </div>
//                   </button>
//                 </a>
//               </div>
//               <div className=" flex items-center md:justify-center justify-start gap-6 sm:text-xs text-[9px] text-[#0000004D]">
//                 <span>© 2025 Zero Typing AI</span>
//                 <NavLink
//                   to="/data-processing-terms"> <span>Security</span> </NavLink>
//                 <NavLink
//                   to="/privacy-policy">  <span>Privacy</span> </NavLink>
//                 <NavLink
//                   to="/terms-of-service">        <span>Terms</span> </NavLink>
//               </div>
//             </div>
//             {/* <div className=" flex items-center md:justify-center justify-start gap-6 sm:text-xs text-[9px] text-[#0000004D]">
//               <span>© 2025 Zero Typing AI</span>
//               <NavLink
//                 to="/data-processing-terms"> <span>Security</span> </NavLink>
//               <NavLink
//                 to="/privacy-policy">  <span>Privacy</span> </NavLink>
//               <NavLink
//                 to="/terms-of-service">        <span>Terms</span> </NavLink>
//             </div> */}
//           </div>
//         </div>
//       </div>
//       {isOpenSuccess && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
//           <div className="bg-[#323232B2] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
//             <div className=" w-[full] flex justify-center items-center flex-col gap-3">
//               <img src={success} className="w-16 " alt="" />
//               <span className=" capitalize text-[#00FF1E] font-semibold leading-none">
//                 success!
//               </span>
//               <span className=" text-center text-white">
//                 Your submission was successful! You’ve been added to the waiting
//                 list and we’ll keep you updated with the latest news through the
//                 provided email address.
//               </span>
//             </div>
//             <div className="w-full">
//               <button
//                 onClick={() => setIsOpenSuccess(false)}
//                 className=" bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
//               >
//                 Done
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isOpenError && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 backdrop-blur-sm">
//           <div className="bg-[#323232B2] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
//             <div className=" w-[full] flex justify-center items-center flex-col gap-3">
//               <img src={error} className="w-16 " alt="" />
//               <span className=" capitalize text-[#f04349] font-semibold leading-none">
//                 error!
//               </span>
//               <span className=" text-center text-white">
//                 Oops! Something went wrong. Please check your details and try
//                 again, or refresh the page and resubmit your information. If the
//                 error persists please contact support at{" "}
//                 <NavLink
//                   to="mailto:support@zerotyping.ai"
//                   className={"text-blue-500 "}
//                   target="_blank"
//                 >
//                   support@zerotyping.ai
//                 </NavLink>
//               </span>
//             </div>
//             <div className="w-full">
//               <button
//                 onClick={() => setIsOpenError(false)}
//                 className=" bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
//               >
//                 Try Again
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Footer;












import React, { useState, useEffect } from "react";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import facebook from "../../Asset/facebook_f.svg";
import instagram from "../../Asset/instagram_f.svg";
import { ReactSVG } from "react-svg";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import playStore from "../../Asset/paly store.svg";
import appStore from "../../Asset/AppStore.png";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonLoading from "../ButtonLoading";
import success from "../../Asset/success.png";
import error from "../../Asset/error.png";
import { useDownload } from "../../pages/DownloadWindow/DownloadContext";

const RECAPTCHA_SITE_KEY = "6Ld9aNwsAAAAAAzGYSVSmQrsX4tmjFSxYSwKZqQI";

const Footer = () => {
  const pages = [
    { name: "Home", link: "/" },
    { name: "Demo", link: "/demo" },
    { name: "Pricing", link: "/pricing" },
    { name: "Help", link: "/help" },
  ];
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const downloadCtx = useDownload();
  const openInstallModal = downloadCtx?.openInstallModal;
  const [verifying, setVerifying] = useState(false);
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [recaptchaReady, setRecaptchaReady] = useState(false);

  useEffect(() => {
    if (!RECAPTCHA_SITE_KEY) return;

    const scriptId = "recaptcha-v3-script";
    if (document.getElementById(scriptId)) {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => setRecaptchaReady(true));
      }
      return;
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.grecaptcha && window.grecaptcha.ready) {
        window.grecaptcha.ready(() => setRecaptchaReady(true));
      }
    };
    document.body.appendChild(script);
  }, []);

  const executeRecaptcha = async (action) => {
    if (!RECAPTCHA_SITE_KEY) return null;
    if (!window.grecaptcha || !recaptchaReady) {
      throw new Error("reCAPTCHA not ready");
    }
    return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  };

  const sendToZohoBigin = async () => {
    if (!email) {
      toast.error("Please enter the email", { toastId: "footer-email" });
      return;
    }
    setLoading(true);
    setVerifying(true);

    let recaptchaToken = null;
    try {
      recaptchaToken = await executeRecaptcha("newsletter_subscribe");
    } catch (err) {
      toast.error("reCAPTCHA verification failed. Please try again.", { toastId: "footer-recaptcha" });
      setLoading(false);
      setVerifying(false);
      return;
    }
    setVerifying(false);

    const data = {
      data: [
        { Last_Name: email, Email: email, Lead_Source: "Website Subscription" },
      ],
      recaptchaToken,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}proxy/zoho`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setIsOpenSuccess(true);
        setEmail("");
      } else {
        const errorBody = await response.text();
        console.error("Zoho proxy error:", response.status, errorBody);
        setIsOpenError(true);
      }
    } catch (error) {
      console.error("Subscribe request failed:", error);
      setIsOpenError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className=" bg-gradient-to-b from-[#F8F8F8] to-[#F8F8FC00]  w-full font-inter">
        <div className=" w-full  flex flex-col xl:gap-10 gap-6">
          <div className="  border-y xl:px-20  lg:px-10 px-6 py-4 border-[#0000000D] ">
            <div className="max-w-screen-2xl mx-auto flex md:flex-row flex-col md:justify-between items-start md:items-center w-full md:gap-0 gap-2">
              <div className="w-full">
                <ReactSVG
                  src={zeroTypingLogo}
                  beforeInjection={(svg) => {
                    svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
                  }}
                  className=""
                />
              </div>

              <div className="w-full flex justify-start md:gap-6 gap-3 md:text-sm text-xs font-medium">
                {pages?.map((page, i) => (
                  <NavLink
                    to={page.link}
                    key={i}
                    className="hover:text-[#3AB1F6] text-[#292D34] md:pl-8 pl-3 md:first:pl-3 first:pl-0 md:pr-5 border-l border-[#0000000D] md:first:border-l-1 first:border-l-0 gap-6"
                  >
                    {page.name}
                  </NavLink>
                ))}
              </div>
            </div>


          </div>
          <div className="xl:px-20 lg:px-10 px-6 ">
            <div className=" flex md:flex-row flex-col md:items-center max-w-screen-2xl  mx-auto w-full items-start md:gap-4 gap-8 ">
              <div className=" flex-1 w-full flex flex-col gap-4 xl:text-lg lg:text-base md:text-sm text-xs items-start">
                <p>
                  Say goodbye to typos and wasted time - Zero Typing AI{" "}
                  <br className=" lg:flex hidden" /> writes with precision, so
                  you don’t have to.
                </p>
                {/* <div className=" flex items-center gap-3 font-inter">
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
                    <ReactSVG
                      src={microsoftIcon}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
                      <span className=" text-[.6rem] leading-none">
                        Download for
                      </span>
                      <span className=" font-semibold leading-none">
                        Windows
                      </span>
                    </div>
                  </button>


                  <a
                    href="https://play.google.com/store/apps/details?id=ai.zerotyping"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block"
                  >
                    <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg">
                      <ReactSVG
                        src={playStore}
                        beforeInjection={(svg) => {
                          svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
                        }}
                      />
                      <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
                        <span className=" text-[.6rem] leading-none">
                          GET IT ON
                        </span>
                        <span className=" font-semibold leading-none">
                          Google Play
                        </span>
                      </div>
                    </button>
                  </a>
                </div> */}
                <div className=" flex items-center gap-4">
                  <ReactSVG
                    src={facebook}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
                    }}
                    className="w-auto"
                  />
                  <ReactSVG
                    src={instagram}
                    beforeInjection={(svg) => {
                      svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
                    }}
                    className="w-auto"
                  />
                </div>
              </div>
              <div className=" flex-1 w-full flex md:justify-end justify-center ">
                <div className="bg-[#00000005] border border-[#0000000D] flex flex-col gap-4 lg:p-6 p-3 rounded-xl lg:w-[470px] w-full">
                  <p className="md:text-sm text-xs font-inter">
                    Sign up for our newsletter and join the Zero Typing AI
                    community.
                  </p>
                  <div className=" flex md:items-center items-start flex-row gap-2 w-full md:text-sm text-xs">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className=" flex-grow bg-[#fff] lg:w-auto w-full md:p-3  p-2 rounded-lg  placeholder:text-[#757575]"
                      placeholder="Input Email Address"
                    />
                    <button
                      onClick={() => {
                        sendToZohoBigin();
                      }}
                      disabled={loading}
                      className={`flex-none flex items-center justify-center ${loading ? " opacity-50 cursor-not-allowed" : ""
                        } bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] hover:from-[#3AA6E4] hover:to-[#4175EB] transition-all duration-300 ease-in-out lg:w-auto w-max md:p-3  p-2 md:px-4 px-2  rounded-lg  text-[#fff]`}
                    >
                      {loading ? (
                        <ButtonLoading
                          text={verifying ? "verifying..." : "subscribing..."}
                        />
                      ) : (
                        "Subscribe"
                      )}
                    </button>
                  </div>

                  <div className="flex items-start gap-2">
                    <div
                      className={`recaptcha-inline-badge ${verifying ? "is-verifying" : ""} flex items-center justify-center w-10 h-10 rounded-md bg-white border border-[#0000001A] shadow-sm flex-none`}
                    >
                      <img
                        src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
                        alt="reCAPTCHA"
                        className="w-7 h-7"
                      />
                    </div>
                    <div className="text-[10px] text-[#757575] leading-tight">
                      This site is protected by reCAPTCHA and the Google{" "}
                      <a
                        href="https://policies.google.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-[#3c4043]"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://policies.google.com/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-[#3c4043]"
                      >
                        Terms of Service
                      </a>{" "}
                      apply.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className=" text-sm font-inter flex flex-col gap-4 lg:py-10 py-6 border-t xl:px-20  lg:px-10 px-6  border-[#0000000D] ">
            <div className="max-w-screen-2xl  mx-auto flex md:flex-row flex-col-reverse gap-4 justify-between md:items-center items-start w-full ">

              <div className=" flex flex-wrap items-center gap-3 font-inter">
                <a
                  href="https://zerotyping.ai/ztaupdate/ZeroTypingAI.msi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block shrink-0"
                  onClick={() => openInstallModal?.("windows")}
                >
                  <button
                    type="button"
                    className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg whitespace-nowrap"
                  >
                    <ReactSVG
                      src={microsoftIcon}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
                      <span className=" text-[.6rem] leading-none">
                        Download for
                      </span>
                      <span className=" font-semibold leading-none">
                        Windows
                      </span>
                    </div>
                  </button>
                </a>


                <a
                  href="https://play.google.com/store/apps/details?id=ai.zerotyping"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block shrink-0"
                >
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-1.5 px-3 rounded-lg whitespace-nowrap">
                    <ReactSVG
                      src={playStore}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[1.3rem] h-[1.3rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start md:text-base text-sm gap-[2px] ">
                      <span className=" text-[.6rem] leading-none whitespace-nowrap">
                        GET IT ON
                      </span>
                      <span className=" font-semibold leading-none whitespace-nowrap">
                        Google Play
                      </span>
                    </div>
                  </button>
                </a>

                <img
                  src={appStore}
                  alt="Coming soon to the App Store"
                  className="h-[38px] w-auto rounded-lg cursor-pointer shrink-0"
                />
              </div>
              <div className=" flex items-center md:justify-center justify-start gap-6 sm:text-xs text-[9px] text-[#0000004D]">
                <span>© 2025 Zero Typing AI</span>
                <NavLink
                  to="/data-processing-terms"> <span>Security</span> </NavLink>
                <NavLink
                  to="/privacy-policy">  <span>Privacy</span> </NavLink>
                <NavLink
                  to="/terms-of-service">        <span>Terms</span> </NavLink>
              </div>
            </div>
            {/* <div className=" flex items-center md:justify-center justify-start gap-6 sm:text-xs text-[9px] text-[#0000004D]">
              <span>© 2025 Zero Typing AI</span>
              <NavLink
                to="/data-processing-terms"> <span>Security</span> </NavLink>
              <NavLink
                to="/privacy-policy">  <span>Privacy</span> </NavLink>
              <NavLink
                to="/terms-of-service">        <span>Terms</span> </NavLink>
            </div> */}
          </div>
        </div>
      </div>
      {isOpenSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-[#323232B2] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
            <div className=" w-[full] flex justify-center items-center flex-col gap-3">
              <img src={success} className="w-16 " alt="" />
              <span className=" capitalize text-[#00FF1E] font-semibold leading-none">
                success!
              </span>
              <span className=" text-center text-white">
                Your submission was successful! You’ve been added to the waiting
                list and we’ll keep you updated with the latest news through the
                provided email address.
              </span>
            </div>
            <div className="w-full">
              <button
                onClick={() => setIsOpenSuccess(false)}
                className=" bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpenError && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 backdrop-blur-sm">
          <div className="bg-[#323232B2] backdrop-blur-md w-[21rem] p-5 flex flex-col justify-center items-center gap-4 rounded-xl">
            <div className=" w-[full] flex justify-center items-center flex-col gap-3">
              <img src={error} className="w-16 " alt="" />
              <span className=" capitalize text-[#f04349] font-semibold leading-none">
                error!
              </span>
              <span className=" text-center text-white">
                Oops! Something went wrong. Please check your details and try
                again, or refresh the page and resubmit your information. If the
                error persists please contact support at{" "}
                <a
                  href="mailto:support@zerotyping.ai"
                  className={"text-blue-500 "}
                >
                  support@zerotyping.ai
                </a>
              </span>
            </div>
            <div className="w-full">
              <button
                onClick={() => setIsOpenError(false)}
                className=" bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] text-white w-full flex justify-center items-center leading-none py-3 rounded-xl "
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
